import React, { useEffect, useState } from 'react';
// ✅ 1. ASEGÚRATE DE QUE ESTOS ESTÉN IMPORTADOS
import { Redirect, Route, BrowserRouter as Router, Switch, useHistory, useLocation, matchPath } from 'react-router-dom';

import Footer from '../Components/Organisms/Footer/Footer';
import GoogleSearchWrapper from '../Components/Molecules/GoogleSearchWrapper/GoogleSearchWrapper';
import Header from '../Components/Organisms/Header/Header';
import NavbarBackgroundHelper from '../Components/Atoms/NavbarBackgroundHelper/NavbarBackgroundHelper';
import { RoutesConsultancy } from './RoutesConsultancy/RoutesConsultancy';
import { RoutesHome } from './RoutesHome/RoutesHome';
import { RoutesEvents } from './RoutesEvents/RoutesEvents';
import { RoutesJobs } from './RoutesJobs/RoutesJobs';
import { RoutesLiteThinking } from './RoutesLiteThinking/RoutesLiteThinking';
import { RoutesRedirect } from './RoutesRedirect/RoutesRedirect';
import { RoutesServices } from './RoutesServices/RoutesServices';
import { RoutesUniversity } from './RoutesUniversity/RoutesUniversity';
import { RoutesSoftware } from './RoutesSoftware/RoutesSoftware';
import { Suspense } from 'react';
import { getNavbarHeight } from '../Core/Hooks/HooksGenerals/UseMediaQuery';
import { recaptchaSiteKey } from '../Domain/Settings/Keys/Keys';
import MobileMenuOverlay from '../Components/Atoms/MobileMenuOverlay/MobileMenuOverlay';
import FloatingWhatsApp from '../Components/Organisms/FloatingWhatsApp/FloatingWhatsApp';

// ✅ 2. IMPORTA EL COMPONENTE DEL VISOR Y SUS RUTAS
import BrochureViewerPage from '../Components/Pages/BrochureViewerPage/BrochureViewerPage';
// Asumo que creaste un archivo para esta ruta como se sugirió
import { RoutesBrochure } from './RoutesBrochure/RoutesBrouchure'; 

const APP_ROUTES = [
  ...RoutesConsultancy,
  ...RoutesUniversity,
  ...RoutesLiteThinking,
  // No necesitamos la ruta del brochure aquí, porque la manejaremos por separado
  // ...RoutesBrochure, 
  ...RoutesHome,
  ...RoutesServices,
  ...RoutesJobs,
  ...RoutesEvents,
  ...RoutesSoftware
];

const APP_ROUTES_REDIRECT = [...RoutesRedirect];

// El componente AppContent se queda exactamente como lo tienes,
// representando el layout principal de tu aplicación.
const AppContent = () => {
  const location = useLocation();
  const history = useHistory();
  const [showSearchWrapper, setShowSearchWrapper] = useState(false);

  const activeRoute = APP_ROUTES.find(route => 
    matchPath(location.pathname, { path: route.path, exact: route.exact })
  );
  
  const shouldShowWhatsApp = activeRoute ? activeRoute.showWhatsApp : false;

  const handleLoadedCaptcha = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'homepage' }).then((token) => {
        localStorage.setItem('reCaptcha', token);
      });
    });
  };

  const loadRecaptchaOnInteraction = () => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    script.addEventListener('load', handleLoadedCaptcha);
    document.body.appendChild(script);
  };

  const handleUserInteraction = () => {
    loadRecaptchaOnInteraction();
  };

  useEffect(() => {
    window.addEventListener('click', handleUserInteraction, { once: true });
    return () => {
      window.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  return (
    <Suspense fallback={<></>}>
      <NavbarBackgroundHelper />
      <Header
        showSearchWrapper={showSearchWrapper}
        setShowSearchWrapper={setShowSearchWrapper}
        isBgTransparent={false}
      />
      <MobileMenuOverlay />
      <div
        id="contentWrapper"
        style={{
          minHeight: window.innerHeight - getNavbarHeight()
        }}>
        <GoogleSearchWrapper
          showSearchWrapper={showSearchWrapper}
          setShowSearchWrapper={setShowSearchWrapper}
        />
        <Switch>
          {APP_ROUTES_REDIRECT.map((props, index) => (
            <Redirect exact key={index} {...props} />
          ))}
          {APP_ROUTES.map((props, index) => (
            <Route key={index} {...props} />
          ))}
        </Switch>
      </div>
      <Footer />
      <FloatingWhatsApp isVisible={shouldShowWhatsApp} />
    </Suspense>
  );
};

// ✅ 3. AQUÍ HACEMOS LA MAGIA
export const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* RUTA ESPECIAL: Si la URL es /brochure-viewer, renderiza SOLO este componente */}
        <Route path="/:language/brochure-viewer" exact component={BrochureViewerPage} />

        {/* RUTA POR DEFECTO: Para cualquier otra URL, renderiza la app completa con su layout */}
        <Route path="/" component={AppContent} />
      </Switch>
    </Router>
  );
};